import { useEffect, useState } from 'react';
import {
  useQueryData,
  GetInsightByCategoryResponse,
  DEFAULT_OVERRIDE_CACHE_TIME,
  MetaCategoryType,
  useGetInsightByCategory,
} from '@ecolytiq/js-data-provider';

import { RandomInsightByCategory } from 'impactApp/modules/HomePage';
import { useDeps } from 'App/context';
import { useNavigate } from 'react-router-dom';
import { RoutePaths } from 'impactApp/routes';

export const useRandomInsightsByCategoryData = (category: MetaCategoryType) => {
  const { httpClientService } = useDeps();
  const [response, setResponse] = useState<Omit<RandomInsightByCategory, 'isLoading'>>({
    randomInsightByCategory: {},
  });
  const { randomInsightByCategory } = response;
  const navigate = useNavigate();
  const { SSO_PAGE } = RoutePaths;
  const { isLoading, isFetching, data } = useQueryData<{ data: GetInsightByCategoryResponse }>(
    useGetInsightByCategory(httpClientService, category),
    {
      staleTime: DEFAULT_OVERRIDE_CACHE_TIME,
      cacheTime: 0,
    }
  );

  useEffect(() => {
    if (data?.data) {
      setResponse({
        randomInsightByCategory: data.data.randomInsightByCategory,
      });
    } else if (!isLoading && !data) {
      navigate(SSO_PAGE);
    }
  }, [data, setResponse, navigate, SSO_PAGE, isLoading]);

  return {
    isLoading: isLoading || isFetching,
    randomInsightByCategory,
  };
};
